import { supportedChains, supportedChainsIdMapping } from '@/utils'
import { createConfig, http } from 'wagmi'
import { injected, walletConnect } from 'wagmi/connectors'

const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID

export const config = createConfig({
  chains: supportedChains,
  multiInjectedProviderDiscovery: false,
  connectors: [
    injected({
      target: 'metaMask',
    }),
    walletConnect({ projectId, showQrModal: true }),
  ],
  transports: {
    [supportedChainsIdMapping.bahamut]: http(),
    [supportedChainsIdMapping.ocean]: http(),
  },
})
